import { Injectable } from '@angular/core';
import { RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';
import { PermissionGroup, PermissionGroupCollection, PermissionGroupNew, PermissionGroupPatch } from 'ri-api-client';


@Injectable()
export class PermissionGroupService {
    private options: RequestOptions;

    constructor(private apiService: ApiService) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        this.options = new RequestOptions({ headers: headers });
        this.apiService.init();
    }

    getPermissionGroups(archived?: boolean): Observable<PermissionGroupCollection.PermissionGroupCollection> {
        return this.apiService.client.permissionGroups.GET(null, null, null, null, archived)
            .map((res) => {
                return this.apiService.handleResponse(res).results;
        });
    }

    getPermissionGroup(id: number): Observable<PermissionGroup.PermissionGroup> {
        return this.apiService.client.permissionGroups.id(id.toString()).GET()
            .map((res) => {
                return this.apiService.handleResponse(res);
        });
    }

    post(permissionGroup: PermissionGroupNew.PermissionGroupNew): Observable<PermissionGroup.PermissionGroup> {
        return this.apiService.client.permissionGroups.POST(permissionGroup)
            .map((res) => {
                return this.apiService.handleResponse(res);
        });
    }

    update(permissionGroup: PermissionGroupPatch.PermissionGroupPatch, id: number) {
        return this.apiService.client.permissionGroups.id(id.toString()).PATCH(permissionGroup)
            .map((res) => {
                return this.apiService.handleResponse(res);
        });
    }

    activate(id: number) {
        return this.apiService.client.permissionGroups.id(id.toString()).activate.PATCH({})
            .map((res) => {
        });
    }

    archive(id: number) {
        return this.apiService.client.permissionGroups.id(id.toString()).DELETE()
            .map((res) => {
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/api/permission-groups.service.ts